import axios from "axios";

const fetchClientEconodata = () => {
    const token = process.env.REACT_APP_ECONODATA_CLIENT_ID;
    const defaultOptions = {
        // baseURL: 'http://localhost:4000',
        baseURL: process.env.REACT_APP_ECONODATA_CLIENT_URL,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
        },
    };

    // Create instance
    let instance = axios.create(defaultOptions);

    return instance;
};

export default fetchClientEconodata();
